import { BookingEventsInterface } from '../globalState/interfaces/BookingsInterface';
import { endpoints } from '../resources/scripts/endpoints';
import { fetchData, FETCH_METHODS } from './fetchData';

export const apiAppointmentsServiceBookingEventsByAskerId = async (
	userId: string
): Promise<BookingEventsInterface[]> => {
	const url = endpoints.appointmentsServiceBookingEventsByUserId(userId);

	return fetchData({
		url,
		method: FETCH_METHODS.GET
	});
};
